import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-security",
  "use": "icon-security-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-security\"><title></title><g id=\"icon-security_Security\"><path d=\"M16,28C10.39,28,4,19.48,4,12V9.4A3,3,0,0,1,6,6.58l8.32-3a5,5,0,0,1,3.42,0l8.32,3A3,3,0,0,1,28,9.4V12C28,19.48,21.61,28,16,28Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol